<template>
  <div v-if="billCount >= 2" class="bulk-mode-toggle-section">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <label class="section-label mb-0">
        Chế độ nhập liệu
      </label>
      <span class="text-muted small">
        {{ billCount }} hóa đơn đang được xử lý
      </span>
    </div>

    <div class="mode-cards">
      <!-- Shared Mode Card -->
      <div
        class="mode-card"
        :class="{ 'is-active': value === 'SHARED' }"
        @click="onSelect('SHARED')"
      >
        <div class="mode-card-radio">
          <div class="radio-circle"></div>
        </div>
        <div class="mode-card-content">
          <div class="mode-card-title">
            <i class="fas fa-users text-primary mr-2"></i>
            Dùng chung
          </div>
          <div class="mode-card-desc">
            Áp dụng 1 thông tin người mua cho tất cả hóa đơn.
          </div>
        </div>
        <div v-if="detectedMode === 'SHARED'" class="mode-card-badge">
          Khuyên dùng
        </div>
      </div>

      <!-- Per-Bill Mode Card -->
      <div
        class="mode-card"
        :class="{ 'is-active': value === 'PER_BILL' }"
        @click="onSelect('PER_BILL')"
      >
        <div class="mode-card-radio">
          <div class="radio-circle"></div>
        </div>
        <div class="mode-card-content">
          <div class="mode-card-title">
            <i class="fas fa-th-list text-warning mr-2"></i>
            Nhập riêng
          </div>
          <div class="mode-card-desc">
            Nhập hoặc chỉnh sửa thông tin cho từng hóa đơn.
          </div>
        </div>
        <div v-if="detectedMode === 'PER_BILL'" class="mode-card-badge">
          Khuyên dùng
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BulkInputModeToggle',

  props: {
    value: {
      type: String,
      required: true,
      validator: (v) => ['SHARED', 'PER_BILL'].includes(v),
    },
    billCount: { type: Number, default: 0 },
    detectedMode: { type: String, default: null },
    hasUnsavedData: { type: Boolean, default: false },
  },

  methods: {
    onSelect(mode) {
      if (mode === this.value) return;

      if (this.hasUnsavedData) {
        const confirmed = window.confirm(
          'Đổi chế độ có thể mất dữ liệu đã nhập. Bạn có chắc?',
        );
        if (!confirmed) return;
      }

      this.$emit('input', mode);
    },
  },
};
</script>

<style lang="scss" scoped>
$draft-primary: #3699ff;
$draft-bg: #f3f6f9;
$draft-border: #ebedf3;
$draft-text-label: #6c757d;

.bulk-mode-toggle-section {
  margin-bottom: 1.5rem;
}

.mode-cards {
  display: flex;
  gap: 1rem;
}

.mode-card {
  flex: 1;
  display: flex;
  align-items: flex-start;
  padding: 1rem;
  border: 1px solid $draft-border;
  border-radius: 0.5rem;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  background: #fff;

  &:hover {
    border-color: darken($draft-border, 10%);
    background: $draft-bg;
  }

  &.is-active {
    border-color: $draft-primary;
    background: rgba($draft-primary, 0.04);
    box-shadow: 0 0 0 1px $draft-primary;

    .radio-circle {
      border-color: $draft-primary;
      background: $draft-primary;
      box-shadow: inset 0 0 0 3px #fff;
    }
  }
}

.mode-card-radio {
  margin-right: 0.75rem;
  padding-top: 0.15rem;
}

.radio-circle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid $draft-text-label;
  transition: all 0.2s ease;
}

.mode-card-content {
  flex: 1;
}

.mode-card-title {
  font-weight: 600;
  font-size: 0.95rem;
  color: #3f4254;
  margin-bottom: 0.25rem;
  display: flex;
  align-items: center;
}

.mode-card-desc {
  font-size: 0.8rem;
  color: #7e8299;
  line-height: 1.3;
}

.mode-card-badge {
  position: absolute;
  top: -10px;
  right: 10px;
  background: #e1f0ff;
  color: $draft-primary;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
  border: 1px solid rgba($draft-primary, 0.2);
}

.section-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: $draft-text-label;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
</style>
